import { defineStore } from 'pinia'

export const useConfigChangeRequestsStore = defineStore('configChangeRequests', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getConfigChangeRequests: (state) => state.data?.data,
  },
  actions: {
    async indexConfigChangeRequests(params = {}) {
      try {
        const response = await axios.get('config-change-requests', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
